module.exports = __webpack_public_path__ + "static/media/anne.0d54fb98.jpg";